import { REDUX_ACTIONS } from "constants/constants";

const initialState = {
  name: "",
};

const clDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REDUX_ACTIONS.FETCH_CL_DETAILS:
      return action.payload;
    case REDUX_ACTIONS.RESET_CL_DETAILS:
      return initialState;
    default:
      return state;
  }
};

export default clDetailsReducer;
